const DASHBOARD = '/dashboard'
const LOGIN = '/auth/login'
const LIST = '/list'
const ANALYSIS = '/analysis'
const ANALYSIS_EXPORT_ALL = '/analysis/all/export'
const ANALYSIS_SCOPE1 = '/analysis/scope-1'
const ANALYSIS_EXPORT_SCOPE1 = '/analysis/scope-1/export'
const ANALYSIS_SCOPE2 = '/analysis/scope-2'
const ANALYSIS_EXPORT_SCOPE2 = '/analysis/scope-2/export'
const FORGOT_PASSWORD = '/auth/forgot-password'
const CHANGE_PASSWORD = '/auth/change-password'
const CONTACT_US = '/contact'
const EMISSON = '/emission'
const REGISTRATION = '/v1/registration-data'
const REGISTRATION_DOWNLOAD_CSV = `${REGISTRATION}/csv-download?filePath=`
const COUNTRY = '/v1/countries'
const SCOPE = '/v1/scopes'
const ANALYSIS_OTHER = '/analysis/other'
const ANALYSIS_OTHER_EXPORT = '/analysis/other/export'
const SETTING_ALL_BRANCH = '/setting/branches'
const USER = '/v1/users'
const REPORT = '/report'
const GARGABE = '/v1/documents'
const USER_ID = '/v1/auth/me'
const SETTING_BRANCH = '/v1/branches'
const RESET_PASSWORD = '/auth/reset-password'
const UPDATE_SELECT_BRANCH = '/v1/users/branch-select'
const MANUAL_UPLOAD = `${REGISTRATION}/manual-upload`
const UPLOAD_EXCEL = `${REGISTRATION}/upload-excel`
const INVOICE_OCR_ANALYZE = '/v1/invoice-ocr/analyze'
const PAYMENT_HISTORY = '/payment/user-payments'
const PAYMENT_CREATE_SUBSCRIPTION = '/payment/create-subscription'
const PAYMENT_SUCCESS = '/payment/payment-success'
const PAYMENT_FAILURE = '/payment/payment-failure'
// const PAYMENT_CANCEL_SUBSCRIPTION = '/payment/cancel-subscription'
const PAYMENT_CANCEL_SUBSCRIPTION = '/payment/send-cancel-request'
const CHECK_SUBSCRIPTION = '/auth/me'
const GET_PARENT_USER = '/v1/users/parent'
const GET_UNREAD_NOTI = '/notification/unread'
const MARK_AS_READ_NOTI = '/notification/mark-as-read'
const NOTIFICATION = '/notification'
const ITEM = '/item'
const SETTING_BRANCH_CHECK = '/setting/branch-check'
const ANALYSIS_SCOPE3 = '/analysis/scope-3'
const IMAGE_MANAGEMENT = '/image-managements'
const GET_DATA_EMISSION_SCOPE3 = '/category/scope3'
const SYSTEM_SETTING = '/system-setting'
const UPDATE_EMISSION_SCOPE3 = '/emission/update'
const REGISTRATION_UPLOAD_IMAGE = `${REGISTRATION}/create-with-image`
const DELETE_EMISSION_SCOPE3 = '/emission'
const CHECK_DELETE_EMISSION_SCOPE3 = '/emission/check'
const UPDATE_DATA_UPLOAD_IMAGE = `${REGISTRATION}/update-with-image`
const CHECK_DELETE_BRANCH = '/setting/branch/check'
const CHECK_DELETE_BRANCH_ID = '/setting/branch-check'
const GHG = '/ghg'
const UPLOAD_LIST = '/upload/list'
const UPDATE_TUTORIAL_STEP = '/v1/users/update-tutorial'
const DOCUMENTS = '/v1/documents'
const SETTING_PASSWORD = '/auth/set-password'
const COMPANIES = '/v1/companies'
const COMPANIES_SHARED = '/v1/companies/shared'
const GROUP = '/v1/groups'
const GROUP_COMPANY = '/v1/group-companies'
const CLASSIFICATIONS = '/v1/classifications'
const SEARCH_CONDITION = '/v1/search-conditions'
const ANALYSIS_FILTER_SETTING = '/v1/analysis-filter-settings'
const SHARE_DATA = '/v1/share-datas'
const GOAL = '/v1/goal-versions'
const CUT_OFF = '/v1/cut-off'
const ACCOUNT_INFO = 'v1/users'
const REGISTRATIONS = '/v1/registrations'
const UPLOAD_HISTORIES = '/v1/upload-histories'

const EMISSION_CUT_STRATEGIES = '/v1/emission-cut-strategies'
const VERIFY_EMAIL = '/auth/verify-change-email'

export const getFolderRoute = (id: string) => `/v1/documents/${id}/folders`

export const getRenameFolderRoute = (id: string) => `/v1/documents/${id}/rename`

export {
  GARGABE,
  DASHBOARD,
  LOGIN,
  LIST,
  ANALYSIS,
  ANALYSIS_EXPORT_ALL,
  ANALYSIS_SCOPE1,
  ANALYSIS_EXPORT_SCOPE1,
  ANALYSIS_SCOPE2,
  ANALYSIS_EXPORT_SCOPE2,
  FORGOT_PASSWORD,
  CHANGE_PASSWORD,
  CONTACT_US,
  EMISSON,
  REGISTRATION,
  SCOPE,
  COUNTRY,
  ANALYSIS_OTHER,
  ANALYSIS_OTHER_EXPORT,
  SETTING_ALL_BRANCH,
  USER,
  REPORT,
  SETTING_BRANCH,
  USER_ID,
  RESET_PASSWORD,
  UPDATE_SELECT_BRANCH,
  MANUAL_UPLOAD,
  PAYMENT_HISTORY,
  PAYMENT_CREATE_SUBSCRIPTION,
  PAYMENT_SUCCESS,
  PAYMENT_FAILURE,
  PAYMENT_CANCEL_SUBSCRIPTION,
  CHECK_SUBSCRIPTION,
  GET_PARENT_USER,
  GET_UNREAD_NOTI,
  MARK_AS_READ_NOTI,
  ITEM,
  SETTING_BRANCH_CHECK,
  ANALYSIS_SCOPE3,
  IMAGE_MANAGEMENT,
  GET_DATA_EMISSION_SCOPE3,
  SYSTEM_SETTING,
  UPDATE_EMISSION_SCOPE3,
  REGISTRATION_UPLOAD_IMAGE,
  DELETE_EMISSION_SCOPE3,
  CHECK_DELETE_EMISSION_SCOPE3,
  UPDATE_DATA_UPLOAD_IMAGE,
  CHECK_DELETE_BRANCH,
  CHECK_DELETE_BRANCH_ID,
  GHG,
  UPDATE_TUTORIAL_STEP,
  UPLOAD_LIST,
  DOCUMENTS,
  REGISTRATION_DOWNLOAD_CSV,
  COMPANIES,
  NOTIFICATION,
  COMPANIES_SHARED,
  SETTING_PASSWORD,
  GROUP,
  GROUP_COMPANY,
  CLASSIFICATIONS,
  SEARCH_CONDITION,
  ANALYSIS_FILTER_SETTING,
  SHARE_DATA,
  GOAL,
  CUT_OFF,
  EMISSION_CUT_STRATEGIES,
  ACCOUNT_INFO,
  VERIFY_EMAIL,
  REGISTRATIONS,
  UPLOAD_EXCEL,
  UPLOAD_HISTORIES,
  INVOICE_OCR_ANALYZE,
}
